"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPermissionsModal = UserPermissionsModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var permission_1 = require("../../features/apis/permission");
var user_1 = require("../../features/apis/user");
var permissions_1 = require("../../utils/permissions");
var roles_1 = require("../../utils/roles");
function normalizeOverridePermissions(user) {
    var _a;
    return Object.fromEntries(Object.entries((_a = user.permissions) !== null && _a !== void 0 ? _a : {}).filter(function (_a) {
        var value = _a[1];
        return typeof value === "boolean";
    }));
}
function UserPermissionsModal(props) {
    var _this = this;
    var _a, _b, _c, _d;
    var isOpen = props.isOpen, user = props.user, clientId = props.clientId, onClose = props.onClose, onSaved = props.onSaved, onRefreshUsers = props.onRefreshUsers;
    var _e = (0, react_2.useState)({}), draftOverrides = _e[0], setDraftOverrides = _e[1];
    var _f = (0, react_2.useState)(""), modalError = _f[0], setModalError = _f[1];
    var _g = (0, react_2.useState)(""), modalSuccess = _g[0], setModalSuccess = _g[1];
    var shouldFetchPermissions = isOpen && Boolean(clientId);
    var rolePermissionsData = (0, permission_1.useGetRolePermissionsQuery)({ clientId: clientId }, { skip: !shouldFetchPermissions }).data;
    var _h = (0, user_1.useUpdateUserPermissionsMutation)(), updateUserPermissions = _h[0], isUpdatingPermissions = _h[1].isLoading;
    (0, react_2.useEffect)(function () {
        if (!isOpen || !user) {
            return;
        }
        setDraftOverrides(normalizeOverridePermissions(user));
        setModalError("");
        setModalSuccess("");
    }, [isOpen, user]);
    var availablePermissions = (_b = (_a = rolePermissionsData === null || rolePermissionsData === void 0 ? void 0 : rolePermissionsData.content) === null || _a === void 0 ? void 0 : _a.availablePermissions) !== null && _b !== void 0 ? _b : [];
    var roleDefaults = (_d = (_c = rolePermissionsData === null || rolePermissionsData === void 0 ? void 0 : rolePermissionsData.content) === null || _c === void 0 ? void 0 : _c.roles) !== null && _d !== void 0 ? _d : [];
    var selectedRoleDefaults = (0, react_2.useMemo)(function () {
        if (!user) {
            return {};
        }
        var resolvedRole = (0, roles_1.resolveUserRole)(user);
        var roleMatch = roleDefaults.find(function (entry) { return entry.role === resolvedRole; });
        if (!roleMatch) {
            return {};
        }
        return Object.fromEntries(availablePermissions.map(function (permission) { var _a; return [permission, ((_a = roleMatch.permissions) === null || _a === void 0 ? void 0 : _a[permission]) === true]; }));
    }, [availablePermissions, roleDefaults, user]);
    var editablePermissions = (0, react_2.useMemo)(function () {
        var _a;
        if (!user) {
            return [];
        }
        var keys = new Set(__spreadArray(__spreadArray([], availablePermissions, true), Object.keys((_a = user.permissions) !== null && _a !== void 0 ? _a : {}), true));
        return Array.from(keys).sort();
    }, [availablePermissions, user]);
    var groupedEditablePermissions = (0, react_2.useMemo)(function () { return (0, permissions_1.groupPermissionsByResource)(editablePermissions); }, [editablePermissions]);
    var getEffectivePermission = function (permission) {
        if (typeof draftOverrides[permission] === "boolean") {
            return draftOverrides[permission];
        }
        return selectedRoleDefaults[permission] === true;
    };
    var handlePermissionToggle = function (permission, checked) {
        var roleDefault = selectedRoleDefaults[permission] === true;
        setDraftOverrides(function (previous) {
            var next = __assign({}, previous);
            if (checked === roleDefault) {
                delete next[permission];
            }
            else {
                next[permission] = checked;
            }
            return next;
        });
        setModalSuccess("");
    };
    var handleSavePermissions = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!user) {
                        return [2 /*return*/];
                    }
                    setModalError("");
                    setModalSuccess("");
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, updateUserPermissions({
                            id: user.uid || user.id,
                            permissions: draftOverrides,
                        }).unwrap()];
                case 2:
                    response = _b.sent();
                    if (!response.success) {
                        setModalError(response.message || "Unable to update user permissions.");
                        return [2 /*return*/];
                    }
                    setModalSuccess("User permission overrides updated.");
                    if (onSaved) {
                        onSaved(draftOverrides);
                    }
                    if (!onRefreshUsers) return [3 /*break*/, 4];
                    return [4 /*yield*/, onRefreshUsers()];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    _a = _b.sent();
                    setModalError("Unable to update user permissions.");
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[760px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { onPress: onClose }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)("h3", { className: "text-lg font-bold text-dark-gray-1", children: "User Permission Overrides" }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-medium-gray", children: user ? "Adjust overrides for ".concat(user.name, " ").concat(user.surname).trim() : "Adjust permission overrides." })] }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Body, { children: [!user ? ((0, jsx_runtime_1.jsx)("p", { className: "text-sm text-medium-gray", children: "Select a user to edit permissions." })) : !groupedEditablePermissions.length ? ((0, jsx_runtime_1.jsx)("p", { className: "text-sm text-medium-gray", children: "No permissions available." })) : ((0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-1 xl:grid-cols-2 gap-4 max-h-[58vh] overflow-auto pr-1", children: groupedEditablePermissions.map(function (group) { return ((0, jsx_runtime_1.jsxs)("div", { className: "rounded-md border border-gray-200 p-4", children: [(0, jsx_runtime_1.jsx)("h4", { className: "text-sm font-semibold text-dark-gray-1 mb-3", children: group.resource.split("_").join(" ") }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-2", children: group.permissions.map(function (permission) {
                                                    var isExplicit = typeof draftOverrides[permission] === "boolean";
                                                    return ((0, jsx_runtime_1.jsxs)("label", { className: "flex items-center justify-between gap-3 text-sm text-dark-gray-1", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)("span", { children: (0, permissions_1.formatPermissionLabel)(permission) }), (0, jsx_runtime_1.jsx)("span", { className: "text-xs ".concat(isExplicit ? "text-primary-navy" : "text-medium-gray"), children: isExplicit ? "Explicit override" : "Inherited from role default" })] }), (0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: getEffectivePermission(permission), onChange: function (event) { return handlePermissionToggle(permission, event.target.checked); }, className: "h-4 w-4 cursor-pointer rounded border-gray-300" })] }, permission));
                                                }) })] }, group.resource)); }) })), modalError && (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-red-600", children: modalError }), modalSuccess && (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-green-700", children: modalSuccess })] }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "secondary", onPress: onClose, isDisabled: isUpdatingPermissions, className: "rounded-md", children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { onPress: handleSavePermissions, isPending: isUpdatingPermissions, isDisabled: !user || isUpdatingPermissions, className: "rounded-md bg-primary-navy text-white hover:bg-primary-navy-light", children: "Save User Permissions" })] })] }) }) }) }));
}
